import React from 'react';
import sprintf from 'sprintf';
import SMUnapprovedBillingList from 'components/dashboard/users/reservations/SMUnapprovedBillingList';
import SMRenderHelper from 'components/helpers/SMRenderHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationUnapprovedView extends React.Component {
  // このクラスはSMUReservationUnapprovedView, SMOReservationUnapprovedViewから呼び出される親クラスです
  constructor(props) {
    super(props);

    this.confirm = this.confirm.bind(this);
    this.reject = this.reject.bind(this);
  }

  confirm(e) {
    if (this.props.delegate && typeof this.props.delegate.confirmUnapprovedReservationActionDidSelect == 'function') {
      this.props.delegate.confirmUnapprovedReservationActionDidSelect(e);
    }
  }

  reject(e) {
    if (this.props.delegate && typeof this.props.delegate.rejectUnapprovedReservationActionDidSelect == 'function') {
      this.props.delegate.rejectUnapprovedReservationActionDidSelect(e);
    }
  }

  renderReservedDateText() {
    const reservation = this.props.reservation;
    const unapproved_reservation = this.props.unapproved_reservation;

    if (unapproved_reservation && reservation.reserved_date_text == unapproved_reservation.reserved_date_text) {
      return (
        <p className="reserve-header__date">
          {SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}
        </p>
      );
    } else {
      return (
        <div>
          <p className="reserve-header__date">
            <del>{SMRenderHelper.renderReservationIcon(reservation)}{reservation.reserved_date_text}</del>
          </p>
          <p className="reserve-header__date">
            <ins>{SMRenderHelper.renderReservationIcon(unapproved_reservation)}{unapproved_reservation.reserved_date_text}</ins>
          </p>
        </div>
      );
    }
  }

  renderSpace() {
    const reservation = this.props.reservation;
    const unapproved_reservation = this.props.unapproved_reservation;

    if(reservation.room.uid == unapproved_reservation.room.uid){
      return(
        <div>
          <p className="reserve-header__space">
            <a target="_blank" href={Routes.space_room_path(reservation.room.space.username, reservation.room.uid)}>{SMFormatHelper.roomName(reservation.room)}</a>（<a target="_blank" href={Routes.space_path(reservation.room.space.username)}>{reservation.room.space.name}</a>）
          </p>
        </div>
      );
    } else if (reservation.room.space.username == unapproved_reservation.room.space.username) {
      return(
        <div>
          <p className="reserve-header__space">
            <a target="_blank" href={Routes.space_room_path(reservation.room.space.username, reservation.room.uid)}><del>{SMFormatHelper.roomName(reservation.room)}</del></a>（<a target="_blank" href={Routes.space_path(reservation.room.space.username)}><ins>{reservation.room.space.name}</ins></a>）
          </p>
          <p className="reserve-header__space">
            <a target="_blank" href={Routes.space_room_path(unapproved_reservation.room.space.username, unapproved_reservation.room.uid)}><ins>{SMFormatHelper.roomName(unapproved_reservation.room)}</ins></a>（<a target="_blank" href={Routes.space_path(unapproved_reservation.room.space.username)}><ins>{unapproved_reservation.room.space.name}</ins></a>）
          </p>
        </div>
      );
    } else {
      return(
        <div>
          <p className="reserve-header__space">
            <a target="_blank" href={Routes.space_room_path(reservation.room.space.username, reservation.room.uid)}><del>{SMFormatHelper.roomName(reservation.room)}</del></a>（<a target="_blank" href={Routes.space_path(reservation.room.space.username)}><del>{reservation.room.space.name}</del></a>）
          </p>
          <p className="reserve-header__space">
            <a target="_blank" href={Routes.space_room_path(unapproved_reservation.room.space.username, unapproved_reservation.room.uid)}><ins>{SMFormatHelper.roomName(unapproved_reservation.room)}</ins></a>（<a target="_blank" href={Routes.space_path(unapproved_reservation.room.space.username)}><ins>{unapproved_reservation.room.space.name}</ins></a>）
          </p>
        </div>
      );
    }
  }

  renderPrice(isOwner) {
    const reservation = this.props.reservation;
    const unapproved_reservation = this.props.unapproved_reservation;

    let dueDateForApproval = null;
    if(reservation.due_date_for_approval) {
      dueDateForApproval = <span className="message-important ml10"> {I18n.t('dashboard.label_000209')}：{reservation.due_date_for_approval}</span>;
    }

    const priceArray = [];
    if (reservation.billing){
      if (isOwner) {
        priceArray.push(sprintf(("%s(" + I18n.t("dashboard.label_000706") + ")"), reservation.billing.total_amount_with_tax_text));
      } else {
        priceArray.push(sprintf(("%s(" + I18n.t("dashboard.label_000706") + ")"), reservation.billing.total_amount_with_tax_text));
      }
    }
    const priceText = priceArray.join(" ");

    if (reservation.billing.total_pay_amount_for_user_with_tax_text == unapproved_reservation.billing.total_pay_amount_for_user_with_tax_text) {
      return(
        <p className="reserve-header__price">
          {priceText}{dueDateForApproval}
        </p>
      );
    } else {
      const unapproved_priceArray = [];
      if (reservation.billing){
        if (isOwner) {
          unapproved_priceArray.push(sprintf(("%s(" + I18n.t("dashboard.label_000706") + ")"), unapproved_reservation.billing.total_amount_with_tax_text));
        } else {
          unapproved_priceArray.push(sprintf(("%s(" + I18n.t("dashboard.label_000706") + ")"), unapproved_reservation.billing.total_pay_amount_for_user_with_tax_text));
        }
      }
      const unapproved_priceText = unapproved_priceArray.join(" ");

      return(
        <div>
          <p className="reserve-header__price">
            <del>{priceText}</del>
          </p>
          <p className="reserve-header__price">
            <ins>{unapproved_priceText}</ins>
            {dueDateForApproval}
          </p>
        </div>
      );
    }
  }

  renderBilling(isOwner) {
    const reservation = this.props.reservation;
    const unapproved_reservation = this.props.unapproved_reservation;

    const billingList = [];
    if (reservation.billing) {
      billingList.push(
        <h2 key={reservation.id + "-title"} className="dashboard-title mb20 mt50">
          {I18n.t("dashboard.label_000132")}
        </h2>
      );
      if (isOwner) {
        billingList.push(
          <SMUnapprovedBillingList key={reservation.id} reservation={reservation} unapproved_reservation={unapproved_reservation} isOwner={true} />
        );
      }
      else {
        billingList.push(
          <SMUnapprovedBillingList key={reservation.id} reservation={reservation} unapproved_reservation={unapproved_reservation} isOwner={false} />
        );
      }
    }

    return(
      billingList
    );
  }

  renderDueDate() {
    const reservation = this.props.reservation;
    const due_date_for_change_approval = reservation.due_date_for_change_approval;

    return (
      <p className="mt30 ta-c">
        {due_date_for_change_approval} までに承諾もしくは却下しなかった場合、旧予約内容のままとなります。
      </p>
    );
  }

}
export default SMReservationUnapprovedView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationUnapprovedView.jsx